module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.goods.length > 0) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.goods), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 8,
        "lg": 6
      }
    }, [_c('div', {
      staticClass: "goods"
    }, [_c('div', {
      staticClass: "goods-thumbnail"
    }, [_c('img', {
      attrs: {
        "src": item.pics[0],
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-caption"
    }, [_c('div', {
      staticClass: "goods-title"
    }, [_vm._v("\n              " + _vm._s(item.itemName) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "goods-title"
    }, [(item.special_type == 'drug') ? _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("处方药")]) : _c('span', {
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v("非处方药")])]), _vm._v(" "), _c('div', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.item_bn))]), _vm._v(" "), _c('div', {
      staticClass: "goods-sku"
    }, [(!item.nospec) ? [_vm._v("\n                " + _vm._s(item.spec_items.length > 0 ? '已选' + item.spec_items.length : '全规格') + " "), _c('div', {
      staticClass: "goods-sku-check",
      on: {
        "click": function($event) {
          return _vm.handleSkuDialogShow(index)
        }
      }
    }, [_vm._v("选择规格")])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
      staticClass: "goods-remove iconfont icon-trash-alt",
      on: {
        "click": function($event) {
          return _vm.handleSkuRemove(index)
        }
      }
    })])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleGoodsDialogShow
    }
  }, [_vm._v("选择商品+")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择sku",
      "visible": _vm.dialogVisible,
      "width": "50%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "skuTable",
    attrs: {
      "data": _vm.skus
    },
    on: {
      "selection-change": _vm.handleSkuChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.item_spec_desc) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            ¥" + _vm._s(scope.row.price / 100) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSkuSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('GoodsSelector', {
    attrs: {
      "single": _vm.singleData,
      "items-visible": _vm.itemVisible,
      "get-status": _vm.setItemStatus,
      "rel-items-ids": _vm.relItems,
      "item-type": _vm.item_type
    },
    on: {
      "chooseStore": _vm.handleGoodsSubmit,
      "closeStoreDialog": _vm.handleGoodsDialogHide
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-51e49b07", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e49b07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/function/skuSelector.vue
// module id = 2708
// module chunks = 0